import { Button, type ButtonProps } from '../components/buttons/Button';

export interface SectionHeaderProps {
	title: string;
	sectionButtonProps?: ButtonProps;
}

export function SectionHeader({ title, sectionButtonProps }: SectionHeaderProps) {
	return (
		<div className="flex min-h-[30px] items-center justify-between px-5 py-3">
			<div className="flex items-center gap-3">
				<h3 className="font-semibold uppercase tracking-wider text-gray-500">{title}</h3>
			</div>
			{sectionButtonProps && <Button actionType="edit" intent="neutral" appearance="outline" size="sm" label="Edit" {...sectionButtonProps} />}
		</div>
	);
}
